import { createFileRoute } from '@tanstack/react-router';

import { ReferenceIndexPage } from '@/features/docs';

export const Route = createFileRoute('/_authed/docs/api/')({
  component: ReferenceIndexPage,
});
